export const TRACK_TYPES = {
  TRACK_VIEW: 'trackPageView',
};
